import {axios, SERVICE_AUTHENTICATION_DEV} from '../../utils/request'
import path from "../../api/path";

export function encodePath(params) {
    const url = '/' + path.locService + '/encode'
    return axios({
        url: url,
        method: 'post',
        params: params
    })
}

export function loginAction(params) {
    const url = '/' + path.locService + '/user/login'
    return axios({
        url: url,
        method: 'post',
        data: params
    })
}

export function getImgUrl(imgUrl) {
    const url = '/' + path.locService + imgUrl
    return axios({
        url: url,
        method: 'get',
        responseType: 'blob'
    })
    //
    // return  new Promise((resolve, reject) => {
    //     axios({
    //         url: url,
    //         method: 'get',
    //         // responseType: 'blob'
    //     }).then(res => {
    //         const content = res.data;
    //         resolve(res)
    //     }).catch(error => {
    //         reject(error)
    //     })
    // });
}

export function adfsRequest() {
    const url = '/' + path.locService + '/adfs/acs'
    return new Promise((resolve, reject) => {
        axios({
            url: url,
            method: 'post',
        }).then(res => {
            resolve(res)
        }).catch(error => {
            reject(error)
        })
    });
}


export function getExternalUrl() {
    const url = '/' + path.locService + '/system/config/external'
    return axios({
        url: url,
        method: 'post',
    })
}

export function getInternalUrl() {
    const url = '/' + path.locService + '/system/config/internal'
    return axios({
        url: url,
        method: 'post',
    })
}

export function registerUser(param) {
    const url = '/' + path.locService + '/auth/lenovoid/register';
    return axios({
        url: url,
        method: 'post',
        data: param

    })

}
